import { visVideoLinkAtom } from '@/atoms/navigation';
import { playerIdAtom } from '@/atoms/player/player';
import { PitchSelectVideoPreview } from '@/components/video/PitchSelectVideoPreview';
import { LinkConfig } from '@/types/navigation';
import { useAtomValue, useSetAtom } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import { useEffect } from 'react';

const playerVisVideoPreviewLink: LinkConfig = {
  path: '/:language/player/:playerId/vis/video/preview',
  relative: 'path',
  params: [],
};

const SetVisVideoLink = () => {
  const setVisVideoLink = useSetAtom(visVideoLinkAtom);

  useEffect(() => {
    setVisVideoLink(playerVisVideoPreviewLink);
  }, []);

  return null;
};

export const PlayerPitchVisVideoPreview = () => {
  const playerId = useAtomValue(playerIdAtom);

  return (
    <ScopeProvider atoms={[visVideoLinkAtom]}>
      <SetVisVideoLink />
      {playerId && <PitchSelectVideoPreview ids={{ playerId }} />}
    </ScopeProvider>
  );
};
